import * as types from './mutation-types'
import { ROUTE_NAME } from 'enums/routes'

const PAGE_SEO_MODEL = {
  MetaTitle: '',
  MetaDescription: '',
  Directives: '',
  Keyphrases: []
}

const PAGE_SEO_BY_ROUTE_NAME = {
  [ROUTE_NAME.HOMEPAGE]: {
    MetaTitle: 'Finance Magnates Group | Advertising Solutions',
    MetaDescription:
      "Maximize your growth with Finance Magnates Group's premium advertising network, featuring Finance Magnates, ForexLive, and FMevents. Start, Grow, and Scale with us.",
    Directives: '',
    Keyphrases: []
  }
}

export const state = () => ({
  pageSeo: { ...PAGE_SEO_MODEL },
  ogSiteName: ''
})

export const getters = {
  pageSeo: state => state.pageSeo,
  ogSiteName: state => state.ogSiteName
}

export const actions = {
  /**
   * TODO connect to BE here if requested
   */
  async requestPageSeo({ commit }, { routeName }) {
    const seoData = PAGE_SEO_BY_ROUTE_NAME[routeName]
    commit(types.SET_PAGE_SEO, seoData)
  }
}

export const mutations = {
  [types.SET_PAGE_SEO](state, seo) {
    state.pageSeo = seo || {}
  }
}
